module.exports = __webpack_public_path__ + "media/Video 126.68d64244.mp4";